<template>
  <div class="flex flex-row gap-8 justify-between">
    <StackedLabelInputNumberNoForm
      v-model="daysTemp"
      name="Days"
      label="Days"
      :min="0"
      show-buttons
      input-class="w-28"
    ></StackedLabelInputNumberNoForm>
    <StackedLabelInputNumberNoForm
      v-model="monthsTemp"
      name="Months"
      label="Months"
      :min="0"
      show-buttons
      input-class="w-28"
    ></StackedLabelInputNumberNoForm>
    <StackedLabelInputNumberNoForm
      v-model="yearsTemp"
      name="Years"
      label="Years"
      :min="0"
      show-buttons
      input-class="w-28"
    ></StackedLabelInputNumberNoForm>
  </div>
  <SubmitOptions class="mt-4" @submitted="submitRange" @cancelled="$emit('cancelled')"></SubmitOptions>
</template>

<script setup lang="ts">
import type { ProjectAgingRange } from "@/types/Dashboard";

const projectAgingRange = defineModel<ProjectAgingRange>("projectAgingRange", { required: true });

const emit = defineEmits<{
  submitted: [];
  cancelled: [];
}>();

const daysTemp = ref<number>(projectAgingRange.value.days);
const monthsTemp = ref<number>(projectAgingRange.value.months);
const yearsTemp = ref<number>(projectAgingRange.value.years);

const submitRange = (): void => {
  if (daysTemp.value == 0 && monthsTemp.value == 0 && yearsTemp.value == 0) {
    error("Invalid Aging Ranging", "Range must be greater than 0");
    return;
  }

  projectAgingRange.value.days = daysTemp.value;
  projectAgingRange.value.months = monthsTemp.value;
  projectAgingRange.value.years = yearsTemp.value;
  emit("submitted");
};
</script>
